<template>
  <b-container fluid
               class="p-0">
    <div class="esg-home-container">
      <b-col class="section">
        <div class="content-wrap">
          <span class="title">온실가스 관리</span>
          <ul class="list">
            <li class="list-item">온실가스 인벤토리 관리</li>
            <li class="list-item">탄소 발자국 관리</li>
          </ul>
          <button @click="pushRoute('/esg/ghg-emission-amount-management')">바로 가기
            <b-icon-arrow-right/>
          </button>
        </div>
      </b-col>
      <b-col class="section">
        <div class="content-wrap">
          <span class="title">ESG 공시</span>
          <ul class="list">
            <li class="list-item">ESG 보고서 발간 지원</li>
          </ul>
          <button @click="pushRoute('/esg/disclosure-templates')">바로 가기
            <b-icon-arrow-right/>
          </button>
        </div>
      </b-col>
      <b-col class="section">
        <div class="content-wrap">
          <span class="title">ESG Data</span>
          <ul class="list">
            <li class="list-item">데이터 대시보드</li>
            <li class="list-item">데이터 관리</li>
          </ul>
          <button disabled>바로 가기
            <b-icon-arrow-right/>
          </button>
        </div>
      </b-col>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "EsgHome",
}
</script>

<style scoped>
.esg-home-container {
  height: 100%;
  background-image: url("../../../assets/images/forrest.jpg");
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  background-color: rgba(46, 46, 56, .8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.section {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section .content-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section .content-wrap .title {
  padding: .5rem 1.5rem;
  color: #fff;
  font-size: 2.5rem;
  border-bottom: 1px solid #fff;
  font-weight: 600;
}

.section:first-child {
  border-right: 2px solid #fff;
}

.section:last-child {
  border-left: 2px solid #fff;
}

.section:last-child .content-wrap .title {
}

.section .content-wrap .list {
  height: 150px;
  padding: 1.5rem;
}

.section .content-wrap .list .list-item {
  padding: .25rem;
  color: #fff;
  font-size: 1.25rem;
}

.section .content-wrap button {
  display: block;
  height: 50px;
  width: 200px;
  border: none;
  padding-right: 1rem;
  padding-left: 1rem;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, .25);
  color: #fff;
  font-size: 1.5rem;
  transition: background-color 0.3s;
}

.section .content-wrap button:hover {
  background-color: rgba(255, 255, 255, .4);
}

@media (max-width: 850px) {
  .esg-home-container {
    flex-direction: column;
  }

  .section {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .section:first-child {
    border-right: none;
    border-bottom: 2px solid #fff;
  }

  .section:last-child {
    border-left: none;
    border-top: 2px solid #fff;
  }
}
</style>